import React from 'react';
import { Outlet, Link } from 'react-router-dom';

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-background text-textPrimary font-sans selection:bg-primary/30">
      {/* Header */}
      <header className="border-b border-white/10 px-6 py-4 flex items-center justify-between sticky top-0 bg-background/80 backdrop-blur-md z-50">
        <div className="flex items-center gap-8">
          <Link to="/" className="font-bold text-xl tracking-tight flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-primary rounded-lg flex items-center justify-center text-white font-bold">P</div>
            <span className="text-white">PodVault</span>
          </Link>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-400">
            <Link to="/topics" className="hover:text-white transition-colors">Topic Engine</Link>
            <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
          </nav>
        </div>
        <div className="flex items-center gap-4">
            <Link to="/login" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">Log in</Link>
            <Link to="/pricing" className="text-sm font-bold bg-white/10 border border-white/20 text-white px-4 py-2 rounded-full hover:bg-white/20 transition-all hover:scale-105">Make My Podcast Immortal</Link>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-12 mt-20 bg-black/20">
        <div className="container mx-auto px-6 text-center text-slate-500 text-sm">
          &copy; {new Date().getFullYear()} PodVault. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
